<template>
    <div class="kgk-user-run-create">
        <h3 v-if="!insideModal">
            Lauf eintragen
        </h3>
        <div class="kgk-form-row">
            Anzahl an Schritten
            <div class="kgk-input-group">
                <div class="kgk-input-group-append">Schritte</div>
                <input type="text" v-model.number="form.steps" v-on:change="calculateLength()">
            </div>
            <div v-if="showValidationErrors && !stepsRequiredValidation" class="kgk-form-validation-error-inline">Bitte deine Schritte an.</div>
        </div>
        <div class="kgk-form-row">
            Gelaufene Distanz
            <div class="kgk-input-group">
                <div class="kgk-input-group-append">km</div>
                <input type="text" v-model="form.length" disabled="disabled" placeholder="Wird automatisch berechnet">
            </div>
        </div>
        <div v-if="!edit || !detailsLoading">
            <form @submit.prevent="createRun">
                <div class="kgk-form-row">
                    Datum
                    <p style="font-size: 12px;">Schritte können nur Tageweise eingereicht werden.</p>
                    <div class="kgk-input-group">
                        <div class="kgk-input-group-prepend">
                            <i class="fas fa-calendar-alt fa-fw"></i>
                        </div>
                        <Datetime
                                type="date"
                                format="dd.LL.yy"
                                value-zone="UTC+2"
                                zone="UTC+2"
                                v-model="form.ran_at.date"
                                inputClass="form-control text-center"
                                auto
                                :min-datetime="minDatetime"
                                :max-datetime="maxDatetime"
                                :disabled-dates="blockedDates"
                                :phrases="{cancel: 'Abbrechen', ok: 'Übernehmen'}">
                        </Datetime>
                    </div>
                    <div v-if="showValidationErrors && !ranAtDateRequiredValidation" class="kgk-form-validation-error-inline">Bitte gib ein Datum an.</div>
                </div>
                
                <div class="spacer-small"></div>
                <div v-if="!insideModal" class="kgk-form-row">
                    <button type="submit">
                        <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                        <span class="button-text">Schritte eintragen</span>
                    </button>
                </div>
            </form>
        </div>
        <div v-else-if="edit && detailsLoading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
    </div>
</template>

<script>
    import runs from '../../api/runs';
    import { Datetime } from 'vue-datetime';
    import user from '@/api/user';

    const lengthRegex = /^\s*\d+([.,]\d+)?\s*$/; // basically int or float value with comma or dot separator

    export default {
        name: 'CreateRunStepsForm',
        components: {
            Datetime,
        },
        props: {
            edit: {
                type: Boolean,
                required: true
            },
            insideModal: {
                type: Boolean,
                required: true,
                default: false,
            },
            modalSaveTrigger: {
                type: Object,
                required: false
            },
            runIdentifier: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                competitiveLoading: false,
                detailsLoading: false,
                loading: false,
                competitive: null,
                form: {
                    editIdentifier: null,
                    length: '',
                    steps: 0,
                    ran_at: {
                        date: '',
                        time: '',
                    },
                    run_type: 1
                },
                blockedDates: ["2024-07-06","2024-08-16","2024-09-22","2024-09-29","2024-10-02","2024-10-05"],
                user_stride: this.$parent.$parent.$parent.user.stride,
                isInvalidated: false,
                showValidationErrors: false,
                minDatetime: '2024-04-15T00:00:00Z', // @TODO: read from window.kgkConfig ?
                maxDatetime: (new Date()).toISOString(),
                error: '',
                maximumLengthValue: 500000, // @Todo: read from window.kgkConfig
            }
        },
        computed: {
            lengthRequiredValidation() {

                return this.form.length > 0;
            },
            lengthFormatValidation() {
                if( this.form.length == 0 ) {
                    return true;
                }

                return lengthRegex.test(this.form.length);
            },
            lengthFloat() {
                
                return true;
            },
            stepsRequiredValidation() {
                if(typeof this.form.steps !== 'undefined' || this.form.steps > 0){
                    return true;
                }else{
                    return false;
                }
            },
            lengthValueValidation() {
                return this.lengthFloat < this.maximumLengthValue;
            },
            ranAtDateRequiredValidation() {
                return !!this.form.ran_at.date;
            },
        },
        methods: { 
            loadUserCompetitiveState() {
                this.competitiveLoading = true;

                user.getDetails(
                    this,
                    data => {
                        this.competitive = data.user.competitive;
                    },
                    () => console.warn('Es ist ein Fehler aufgetreten'),
                    () => this.competitiveLoading = false,
                );
            },
            createRun(/*calledFromModal*/) {
                //calledFromModal = calledFromModal || false;

                if( this.loading ) {
                    return;
                }

                this.showValidationErrors = true;

                if( !this.lengthRequiredValidation
                    || !this.lengthFormatValidation
                    || !this.stepsRequiredValidation
                    || !this.lengthValueValidation
                    || !this.ranAtDateRequiredValidation ) {
                    this.$notify({
                        type: 'warn',
                        title: 'Eingaben fehlerhaft.',
                        text: 'Bitte korrigiere deine Formulareingaben.'
                    });

                    return;
                }

                this.loading = true;

                //if( calledFromModal ) {
                    this.$emit('loadingStarted');
                //}

                const data = JSON.parse(JSON.stringify(this.form));

                // prepare data
                data.length = this.form.length;

                // convert date+time to SQL datetime format
                data.ran_at = data.ran_at.date.split('T')[0] + ' ' + data.ran_at.time.split(/T|\./)[1];

                if( !this.edit ) {
                    runs.create(
                        this,
                        data,
                        () => {
                            this.$notify({
                                type: 'success',
                                title: 'Schritte eingetragen',
                                text: `Deine Schritte wurden erfolgreich eingestellt.`
                            });

                            this.$emit('created');
                        },
                        e => {
                            //console.error(e.response.status);
                            if( e.response.status == 400 ) {
                                /*if( typeof e.response.data.field !== 'undefined' ) {
                                    // maybe highlight error field
                                }*/

                                this.$notify({
                                    type: 'error',
                                    title: 'Fehler',
                                    text: e.response.data.message
                                });
                                return;
                            }

                            this.$notify({
                                type: 'error',
                                title: 'Es ist ein unbekannter Fehler aufgetreten.',
                                text: 'Bitte versuch es noch einmal.'
                            });
                        },
                        () => {
                            this.loading = false;
                            //if( calledFromModal ) {
                                this.$emit('loadingEnded');
                            //}
                        }
                    );
                }
                else {
                    delete data.editIdentifier;
                    data.identifier = this.form.editIdentifier;

                    runs.update(
                        this,
                        data,
                        () => {
                            this.$notify({
                                type: 'success',
                                title: 'Schritte bearbeitet',
                                text: `Deine Schritte wurden erfolgreich gespeichert.`
                            });

                            this.$emit('edited');
                        },
                        e => {
                            //console.error(e.response.status);
                            if( e.response.status == 400 ) {
                                /*if( typeof e.response.data.field !== 'undefined' ) {
                                    // maybe highlight error field
                                }*/

                                this.$notify({
                                    type: 'error',
                                    title: 'Fehler',
                                    text: e.response.data.message
                                });
                                return;
                            }

                            this.$notify({
                                type: 'error',
                                title: 'Es ist ein unbekannter Fehler aufgetreten.',
                                text: 'Bitte versuch es noch einmal.'
                            });
                        },
                        () => {
                            this.loading = false;
                            //if( calledFromModal ) {
                                this.$emit('loadingEnded');
                            //}
                        }
                    );
                }

                return true;
            },

            loadCurrentTimeInForm(){
                this.form.ran_at.date = (new Date()).toISOString();
                this.form.ran_at.time = (new Date()).toISOString();
            },
            calculateLength(){
                //this.form.steps = parseInt(this.form.steps);
                this.form.length = this.user_stride * this.form.steps / 100000;
            },
            loadBlockedDates(){
                runs.getBlockedDates(
                    this,
                    data => {
                        //this.blockedDates = data.map(date => new Date(date)); // Convert to Date objects
                    },
                    () => this.error = 'Es ist ein Fehler aufgetreten',
                    () => this.loading = false,
                );
            }
        },
        watch: {
            'modalSaveTrigger.trigger'() {
                this.createRun();
                /*const result = this.createRun(true);
                if( result === true ) {

                }*/
            },
        },
        mounted() {
            this.loadUserCompetitiveState();
            this.loadCurrentTimeInForm();
            this.loadBlockedDates();
            

            if( this.edit ) {
                if( !this.runIdentifier ) {
                    console.error('CreateRunForm edit mode requires passing of a run identifier');
                    return;
                }

                this.detailsLoading = true;

                runs.get(
                    this,
                    this.runIdentifier,
                    ({run}) => {
                        this.form.editIdentifier = run.identifier;
                        this.form.length = this.convertNumberReadable(run.length);

                        this.form.ran_at.date = run.ran_at.split(' ')[0] + 'T00:00:00.000';
                        this.form.ran_at.time = (new Date().toJSON()).split('T')[0] + 'T' + run.ran_at.split(' ')[1] + '.000';

                        this.isInvalidated = !!run.invalidated;
                    },
                    () => {
                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });

                        if( this.insideModal ) {
                            this.$emit('modalForceClose');
                        }
                    },
                    () => this.detailsLoading = false,
                );
            }


        }
    }
</script>

